import Thumbnails from './Thumbnails'

export default Thumbnails


// WEBPACK FOOTER //
// ./src/components/FrontPage/Thumbnails/index.js